import { StartFreeSection as StartFree } from '@/components';
import { Box } from '@mui/material';
import { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import styles from './styles.module.scss';

export const StartFreeSection: FC = () => {
  const { t } = useTranslation('ourData');
  return (
    <Box className={styles.section} component="section">
      <StartFree
        title={
          <Trans
            ns="ourData"
            i18nKey="startFree.title"
            components={{
              br: <br />,
            }}
          />
        }
        subtitle={t('startFree.subtitle')}
      />
    </Box>
  );
};
